module.exports = __webpack_public_path__ + "data-table.b0aebd744ce7adb780a9.svg";


//////////////////
// WEBPACK FOOTER
// /home/codevi/Documents/PROJET/resa-parklife/front/src/assets/fonts/data-table/data-table.svg
// module id = ../../../../../src/assets/fonts/data-table/data-table.svg
// module chunks = styles